import React from 'react'
import MicroscopeLineSVG from "../../assets/icons/microscope-line.svg";

const MicroscopeLine = ({ className = '' }) => {
  return (
    <img
      src={MicroscopeLineSVG}
      alt="Microscope Line"
      className={`${className}`}
    />
  );
};

export default MicroscopeLine;
